import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/mobile/49_leaves/49_leaves"
 * Contains 1 texture(s)
 */
export class Mobile49LeavesAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/mobile/49_leaves/49_leaves';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '49_leaves.jpg'
    ] as const;
}
